"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/DataTable/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _createNamedExportFrom(obj, localName, importedName) { Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]}); } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/*
 * DataTable: a server-paged table with sortable columns, a search box, a
 * Filters popover and a pager, built from the Directory patient table's
 * pieces (its table, sort headers, toolbar and pager styles). Pair it with
 * useDataTable, which holds the search, filters, sort and page and calls your
 * fetch:
 *
 *   const table = useDataTable({ fetch, initialSort: { sort: 'name', desc: false }, initialFilters: {} })
 *   <DataTable
 *     label="People" table={table} columns={COLUMNS} rowKey={r => r.UserKey}
 *     searchPlaceholder="Search by name or email"
 *     filters={<DataTableFilterGroup ... />} activeFilters={1}
 *     noun={['person', 'people']} onOpen={row => ...}
 *   />
 */
var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _Popover = require('web/components/Popover'); var _Popover2 = _interopRequireDefault(_Popover);
var _Checkbox = require('web/screens/Broadcast/CampaignPage/Body/MessagesTable/components/Checkbox'); var _Checkbox2 = _interopRequireDefault(_Checkbox);
var _RecipientTable = require('web/screens/Broadcast/RecipientTable');
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);
var _format = require('web/screens/Directory/PatientTable/format');


var _useDataTable = require('./useDataTable'); _createNamedExportFrom(_useDataTable, 'useDataTable', 'useDataTable');


// Placeholder rows while the first page loads (F-4).
const SKELETON_ROWS = 4






























const ariaSort = (sortKey, sort) => sortKey && sort.sort === sortKey
  ? (sort.desc ? 'descending' : 'ascending')
  : undefined

const SortHeader = ({ label, sortKey, sort, onSort }




) => {
  if (!sortKey) return _react2.default.createElement(_react2.default.Fragment, null,  label )
  const isActive = sort.sort === sortKey
  return (
    _react2.default.createElement('span', {
      role: "button",
      tabIndex: 0,
      className: _classBuilder2.default.call(void 0, 'dir-sort', isActive && 'dir-sort--active', isActive && !sort.desc && 'dir-sort--asc'),
      onClick: () => onSort(sortKey),
      onKeyDown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onSort(sortKey)
        }
      }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}

      ,  label 
    )
  )
}

/* One filter as a list of choices, at most one on: pressing the chosen one
 * clears it. */
 const DataTableFilterGroup = ({ label, options, value, onChange }




) => (
  _react2.default.createElement('fieldset', { className: "dir-filters--group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
    , _react2.default.createElement('legend', { className: "dir-filters--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}},  label )
    , _react2.default.createElement('div', { className: "dir-filters--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
      ,  options.map(o => {
        const toggle = () => onChange(value === o.value ? undefined : o.value)
        return (
          _react2.default.createElement('div', { key: o.value, className: "dir-filters--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}
            , _react2.default.createElement(_Checkbox2.default, { isChecked: value === o.value, label: o.label, onChange: toggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}} )
            , _react2.default.createElement('button', { type: "button", className: "dir-filters--name", title: o.label, onClick: toggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}},  o.label )
          )
        )
      })
    )
  )
  ); exports.DataTableFilterGroup = DataTableFilterGroup
























/* DataTableGrid: just the table (sticky header, rows, placeholders, empty
 * state), for a list that needs no search or pager: one that's already all
 * here, like Account → API keys (F-15), or one with its own toolbar that
 * loads as it scrolls, like Account → Audit. DataTable draws its table with
 * it. */
 const DataTableGrid = ({
  label, columns, rows, rowKey, rowLabel, rowClassName, sort, onSort, onOpen, openKey = null,
  isLoading = false, isBusy = isLoading, emptyState, footer,
}) => (
  _react2.default.createElement('div', { className: "campaign--table--wrapper campaign--table--wrapper--scroll" , 'aria-busy': isBusy || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}
    , _react2.default.createElement('table', { className: "campaign--table", 'aria-label': label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}
      , _react2.default.createElement('colgroup', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}
        ,  columns.map(c => _react2.default.createElement('col', { key: c.id, style: c.width ? { width: c.width } : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}} )) 
      )
      , _react2.default.createElement('thead', { className: "campaign--table--head campaign--table--head--sticky" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}}
        , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 154}}
          ,  columns.map(c => (
            _react2.default.createElement('th', { key: c.id, className: c.className, 'aria-sort': sort ? ariaSort(c.sort, sort) : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}}
              ,  sort && onSort
                ? _react2.default.createElement(SortHeader, { label: c.label, sortKey: c.sort, sort: sort, onSort: onSort, __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}} )
                : c.label 
            )
          ))
        )
      )
      , _react2.default.createElement('tbody', { className: "campaign--table--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}}
        ,  !isLoading && rows.map(row => {
          const key = rowKey(row)
          return (
            _react2.default.createElement('tr', {
              key: key,
              className: _classBuilder2.default.call(void 0, 'campaign--table--row', openKey === key && 'campaign--table--row--open', _optionalChain([rowClassName, 'optionalCall', _2 => _2(row)])),
              'aria-label': !onOpen && rowLabel ? rowLabel(row) : undefined,
              ...(onOpen && {
                "tabIndex": 0,
                'aria-label': rowLabel ? `Open ${rowLabel(row)}` : undefined,
                "onClick": () => onOpen(row),
                "onKeyDown": (e) => {
                  if (e.target === e.currentTarget && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault()
                    onOpen(row)
                  }
                },
              }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}}

              ,  columns.map(c => _react2.default.createElement('td', { key: c.id, className: c.className, __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}},  c.cell(row) )) 
            )
          )
        })
        ,  isLoading && Array.from({ length: SKELETON_ROWS }, (_, i) => (
          _react2.default.createElement('tr', { key: `skeleton-${i}`, className: "campaign--table--row", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 189}}
            ,  columns.map(c => _react2.default.createElement('td', { key: c.id, __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}}, _react2.default.createElement('span', { className: "settings--skeleton-cell", __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}} ))) 
          )
        ))
      )
    )
    ,  rows.length === 0 && !isLoading && emptyState && (
      _react2.default.createElement('div', { className: "campaign--table--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}},  emptyState )
    )
    ,  footer 
  )
  ); exports.DataTableGrid = DataTableGrid

const DataTable = ({
  label, table, columns, rowKey, searchPlaceholder, filters, activeFilters = 0, toolbarExtra, noun,
  onOpen, rowLabel, openKey = null, emptyState,
}) => {
  const filtersRef = _react.useRef(null)
  const [isFiltersOpen, setIsFiltersOpen] = _react.useState.call(void 0, false)
  const { rows, total, page, pageSize } = table
  const first = page * pageSize + 1
  const last = Math.min(total, (page + 1) * pageSize)
  return (
    _react2.default.createElement('div', { className: "data-table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}}
      , _react2.default.createElement('div', { className: "recipients-toolbar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 213}}
        , _react2.default.createElement('label', { className: "recipients-toolbar--search", __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}}
          , _react2.default.createElement('img', { alt: "", className: "recipients-toolbar--search-icon", src: "/assets/icons/search-grey.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 215}} )
          , _react2.default.createElement('input', {
            'aria-label': `Search ${noun[1]}`,
            placeholder: searchPlaceholder,
            type: "search",
            value: table.search,
            onChange: e => table.setSearch(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 216}}
          )
        )
        ,  filters && (
          _react2.default.createElement('button', {
            ref: filtersRef,
            type: "button",
            className: "blm-btn blm-btn--secondary data-table--btn"  ,
            'aria-expanded': isFiltersOpen,
            onClick: () => setIsFiltersOpen(o => !o), __self: this, __source: {fileName: _jsxFileName, lineNumber: 225}}

            , _react2.default.createElement('img', { alt: "", src: "/assets/icons/video/filter-black.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}} ), "Filters"

            ,  activeFilters > 0 && _react2.default.createElement('span', { className: "dir-count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 234}},  activeFilters ) 
            , _react2.default.createElement('span', { className: "dir-toolbar--caret", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 235}}, "▾")
          )
        )
        ,  toolbarExtra 
        ,  isFiltersOpen && (
          _react2.default.createElement(_Popover2.default, { anchorRef: filtersRef, align: "right", onClose: () => setIsFiltersOpen(false), className: "dir-popover", __self: this, __source: {fileName: _jsxFileName, lineNumber: 240}}
            , _react2.default.createElement('div', { className: "dir-filters", role: "group", 'aria-label': "Filters", __self: this, __source: {fileName: _jsxFileName, lineNumber: 241}},  filters )
          )
        )
      )
      ,  table.hasError && (
        _react2.default.createElement(_WarningBar2.default, { theme: "warning", linkText: "Try again" , onLinkClick: table.reload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 246}}
          , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 247}}, "This list couldn't load."   ), " Check your connection; nothing was changed."
        )
      )
      , _react2.default.createElement(exports.DataTableGrid, {
        label: label,
        columns: columns,
        rows: rows,
        rowKey: rowKey,
        rowLabel: rowLabel,
        sort: table.sort,
        onSort: table.onSort,
        onOpen: onOpen,
        openKey: openKey,
        isLoading: !table.hasLoaded && table.isLoading,
        isBusy: table.isLoading,
        emptyState: table.hasLoaded ? emptyState : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}}
      )
      ,  table.hasLoaded && !table.hasError && (
        _react2.default.createElement('div', { className: "dir-footer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}
          , _react2.default.createElement('span', { className: "dir-footer--count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}
            ,  total > 0
              ? _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 268}},  _format.formatCount.call(void 0, first) , "–",  _format.formatCount.call(void 0, last) ), " of "  , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 268}},  _format.formatCount.call(void 0, total) ), " " ,  total === 1 ? noun[0] : noun[1] )
              : _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 269}}, "0"), " " ,  noun[1] )
            
          )
          , _react2.default.createElement(_RecipientTable.RecipientPager, { page: page, pageCount: Math.ceil(total / pageSize), onPage: table.setPage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 272}} )
        )
      )
    )
  )
}

exports. default = DataTable
